/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { BlendBridge } from 'blb-types/blendBridge';
import { BaseRedirectTask } from './BaseRedirectTask';

export namespace RedirectTask {
  export interface Props extends BlendBridge.API.RedirectTask {
    onSuccess: () => Promise<any>;
    redirectUrl: string;
    taskId: string;
  }
}

export const RedirectTask: React.FC<RedirectTask.Props> = ({
  taskHeader,
  disabledReason,
  isDisabled,
  onSuccess,
  redirectUrl,
  taskId,
  type,
  buttonLabel = 'Open',
  urlOpenMethod = BlendBridge.API.DirectUrlOpenMethod.NEW_TAB,
}) => {
  return (
    <BaseRedirectTask
      buttonLabel={buttonLabel}
      disabledReason={disabledReason}
      isDisabled={isDisabled}
      key={taskHeader}
      onSuccess={onSuccess}
      redirectUrl={redirectUrl}
      taskHeader={taskHeader}
      taskId={taskId}
      type={type}
      urlOpenMethod={urlOpenMethod}
    />
  );
};
